import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "../../lib/cn";
import { inputClass } from "./Input";

export const Select = forwardRef<
  HTMLSelectElement,
  SelectHTMLAttributes<HTMLSelectElement> & { invalid?: boolean }
>(function Select({ className, invalid, children, ...rest }, ref) {
  return (
    <select
      ref={ref}
      data-invalid={invalid ? "" : undefined}
      className={cn(inputClass, "appearance-none pr-7", className)}
      {...rest}
    >
      {children}
    </select>
  );
});
